import ListAccountSkeleton from './ListAccountSkeleton';

export default ListAccountSkeleton;
